import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Chat", -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Neuen Chat starten: ")
], -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Bitte Benutzer auswählen", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "input-group-append" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-header" }
const _hoisted_12 = { class: "card-title d-flex flex-row justify-content-between" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Deine socket Räume: ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "icon-reload-alt" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "media-list media-list-bordered" }
const _hoisted_17 = { class: "media-body" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "icon-bubble" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.slcEmp) = $event))
          }, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (emp, empIndex) => {
              return (_openBlock(), _createElementBlock("option", {
                key: empIndex,
                value: emp.id
              }, _toDisplayString(emp.firstName) + " " + _toDisplayString(emp.lastName), 9, _hoisted_8))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.slcEmp]
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.newChat && _ctx.newChat(...args)))
            }, "Chat anfragen")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h6", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("button", {
            class: "btn btn-light-100 btn-icon",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.reloadSocketRooms && _ctx.reloadSocketRooms(...args)))
          }, _hoisted_15)
        ])
      ]),
      _createElementVNode("ul", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (room, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: 'room-'+index,
            class: "media"
          }, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createTextVNode(" " + _toDisplayString(room), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}